var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22579 6.93128C7.30701 7.01271 7.30688 7.14455 7.22551 7.22582C7.14413 7.30709 7.0123 7.30705 6.93097 7.22572C6.84965 7.1444 6.84961 7.01256 6.93088 6.93119C7.01215 6.84982 7.14399 6.84969 7.22541 6.93091L7.22579 6.93128",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4956 8.42182C14.9903 8.03672 12.4514 8.86805 10.6591 10.6604C8.86683 12.4527 8.0355 14.9915 8.4206 17.4968",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3282 2.49524H6.66154C4.36035 2.49524 2.49487 4.36072 2.49487 6.66191V13.3286C2.49487 15.6298 4.36035 17.4952 6.66154 17.4952H13.3282C15.6294 17.4952 17.4949 15.6298 17.4949 13.3286V6.66191C17.4949 4.36072 15.6294 2.49524 13.3282 2.49524Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImage);
export default ForwardRef;